import { amVisibleDisplayText } from "../../../ingest-worker/src/am_visible_text";
import { DEFAULT_ASSIGN_ROLE } from "../types.js";

/** `practice-manager` → `Practice Manager` (title-case, hyphens→spaces). */
export function humanizeRole(role: string): string {
  // The role comes from the hub's question, so it is cleaned like any other
  // API text an account manager reads (rule 20). It is a role key, not a
  // company, so it is never a CompanySlug (B2a-8).
  return amVisibleDisplayText(role)
    .split("-")
    .filter((part) => part.length > 0)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

/**
 * Role-picker vocabulary: schema default + knownRoles from Addendum B.
 * Sorted for stable UI; default always present.
 */
export function seedRoleOptions(knownRoles: readonly string[]): string[] {
  const set = new Set<string>([DEFAULT_ASSIGN_ROLE, ...knownRoles]);
  return [...set].sort((a, b) => a.localeCompare(b));
}

/** Hide Reassign when the only seeded option equals the current addressee. */
export function canReassign(currentRole: string, knownRoles: readonly string[]): boolean {
  const options = seedRoleOptions(knownRoles);
  return !(options.length === 1 && options[0] === currentRole);
}
